import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

const g = (p) => axios.get(`${API}${p}`).then((r) => r.data);
const post = (p, b) => axios.post(`${API}${p}`, b).then((r) => r.data);
const patch = (p, b) => axios.patch(`${API}${p}`, b).then((r) => r.data);
const put = (p, b) => axios.put(`${API}${p}`, b).then((r) => r.data);
const del = (p) => axios.delete(`${API}${p}`).then((r) => r.data);

export const apiErr = (e) => {
  const d = e.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join("; ");
  return d || e.message;
};

export const adm = {
  dashboard: () => g("/admin/dashboard"),
  audit: () => g("/admin/audit"),
  list: (res) => g(`/admin/${res}`),
  get: (res, id) => g(`/admin/${res}/${id}`),
  create: (res, body) => post(`/admin/${res}`, body),
  update: (res, id, body) => patch(`/admin/${res}/${id}`, body),
  remove: (res, id) => del(`/admin/${res}/${id}`),
  media: (params = "") => g(`/admin/media${params}`),
  uploadMedia: (formData) => axios.post(`${API}/admin/media`, formData).then((r) => r.data),
  updateMedia: (id, body) => patch(`/admin/media/${id}`, body),
  deleteMedia: (id) => del(`/admin/media/${id}`),
  homepage: () => g("/admin/homepage"),
  saveHomepageDraft: (body) => put("/admin/homepage/draft", body),
  publishHomepage: () => post("/admin/homepage/publish"),
  settings: () => g("/admin/settings"),
  saveSettings: (body) => put("/admin/settings", body),
  subscribers: () => g("/admin/subscribers"),
  members: () => g("/admin/members"),
  orders: () => g("/admin/orders"),
  referrals: () => g("/admin/referrals"),
  adjustPoints: (body) => post("/admin/referrals/adjust", body),
  supporters: () => g("/admin/supporters"),
  reviewSupporter: (id, status) => post(`/admin/supporters/${id}/review`, { approvalStatus: status }),
  syncStripe: (id) => post(`/admin/products/${id}/sync-stripe`),
  vaultNotify: (body) => post("/admin/vault/notify", body),
  generateTeaser: (body) => post("/admin/tracks/teaser/generate", body),
  dvOverview: () => g("/admin/dimension-v/overview"),
  dvFulfillment: (orderNumber, status) => patch(`/admin/dimension-v/orders/${orderNumber}/fulfillment`, { status }),
  dvIssue: (body) => post("/admin/dimension-v/issue", body),
  dvIssueCollection: (body) => post("/admin/dimension-v/issue-collection", body),
  dvRevoke: (id, notes) => post(`/admin/dimension-v/credentials/${id}/revoke`, { notes }),
  dvReissue: (id, notes) => post(`/admin/dimension-v/credentials/${id}/reissue`, { notes }),
  dvEntitlement: (body) => post("/admin/dimension-v/entitlement", body),
  dvPolicy: (body) => put("/admin/dimension-v/policy", body),
  dvContent: (body) => put("/admin/dimension-v/content", body),
  analytics: (days = 30) => g(`/admin/analytics/summary?days=${days}`),
  promotions: () => g("/admin/promotions"),
  createPromotion: (b) => post("/admin/promotions", b),
  updatePromotion: (id, b) => patch(`/admin/promotions/${id}`, b),
  deletePromotion: (id) => del(`/admin/promotions/${id}`),
  promotionStats: (id) => g(`/admin/promotions/${id}/stats`),
};
